import React from 'react';
import { Card } from 'react-bootstrap';

export function Section({ children, prop }) {
  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2 bgcolor-dark">
        <strong>{prop?.label || 'Section'}</strong>
      </Card.Header>
      <Card.Body className="py-4">{children}</Card.Body>
    </Card>
  );
}
export default Section;
